import React            from 'react';
import Lexy360Banner    from './img/Lexy360-Banner.jpg';
import LogoBackground   from './img/Roxx-Racing-Logo-Background.jpg';
import Logos            from './img/Logos.png';
import SocialMediaPosts from './SocialMediaPosts';
import {AppConsumer}    from './App.context';

const NewsPage = () =>
	<AppConsumer>
		{({links}) => (
			<div className="newspage_socialpost-container">
				<SocialMediaPosts initialItemsToShow={8} initialItemsToShowMobile={4} useLoadMore={true} />

				<div className="newspage_lexy360-banner">
					<a href={links.MEDIATHEK} rel="noopener noreferrer">
						<img className="newspage_lexy360-banner--image" src={Lexy360Banner} alt="Lexy360 Teaser" />
						<div className="newspage_contents-teaser--button-container">
							<div className="newspage_contents-teaser--button">Lexy360 anschauen</div>
						</div>
					</a>
				</div>

				<div className="newspage_logos">
					<img className="newspage_logos-background" src={LogoBackground} alt="Background Pattern" />
					<img className="newspage_logos-image" src={Logos} alt="Logos" />
				</div>
			</div>
		)}
	</AppConsumer>;

export default NewsPage




// WEBPACK FOOTER //
// ./src/NewsPage.js